module.exports = function(app) {
	'use strict'
	app.directive('deleteItemDir',deleteItemDir);
	deleteItemDir.$inject=['$rootScope','deleteDataService','refreshtokenService','alertService','serverError','offlineError'];
	function deleteItemDir($rootScope, deleteDataService, refreshtokenService, alertService,serverError,offlineError) {
		return {
			scope:{
				state1:'=',
				state2:'=',
				eleId:'=',
				successDeleteFunc:"="	
			},
            replace:true,
            template:'<li><span class="clickable clickable-danger" ng-click="deleteItem()">Delete</span>&nbsp;|</li>',
			link: function(scope, element, attrs,ctrl) {
                scope.deleteItem = function(tagId) {
                    var deleteFunction = function() {
                      deleteDataService.remove({
                        param1: scope.state1,
                        param2: (scope.state2)?scope.state2:undefined, 
                        param3: scope.eleId
                      }).$promise.then(function(postTag){ 
                        alertService('success','Success ', postTag.message, 2000);
                        $rootScope.hasLoaded = true;
                        if(scope.successDeleteFunc) {
                            scope.successDeleteFunc('update')
                        }
                      }, function(error){
                        if(!window.navigator.onLine) {
                          offlineError()
                          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                          return
                        }
                        if(error.status ==401) {
                          var promise = refreshtokenService.getAccessToken();
                          promise.then(
                            function(answer) {
                              if(answer==200) {   
                               deleteFunction();
                              }
                            },
                            function(error) {
                              // report something
                            },
                            function(progress) {
                             // report progress
                          });
                        } else if(error.status ==502) {
                          serverError();
                        } else {
                          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
                        }  
                      });
                    }
                    deleteFunction();
                }
		  		
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/deleteItemDirective.js
// module id = 439
// module chunks = 0